import { gql } from '@apollo/client';

export const GET_AVAILABLE_LANGUAGES = gql`
  query GetAvailableLanguages($hotelId: ID!) {
    hotel(id: $hotelId) {
      id
      availableLanguages
    }
  }
`;
